import Vue from 'vue';
import Router from 'vue-router';
import Demo from '@/pages/Demo';
import Info from '@/pages/Info';
import SubMenu from '@/pages/SubMenu';
import SubVodMenu from '@/pages/SubVodMenu';
// import Image from '@/components/ViewerImage';
// import Video from '@/components/VideoPlayer';
// import Website from '@/components/WebViewer';
import TVPlayer from '@/pages/TVPlayer';
import RadioPlayer from '@/pages/RadioPlayer';
import KeyHandling from '@/components/InfoKeyHandling';
import InfoDashboard from '@/components/InfoDashboard';

import PageRegistration from '@/pages/Registration';
import Home from '@/pages/Home';
import MediaPlayer from '@/pages/MediaPlayer';
import InputSource from '@/pages/InputSource';
import SourceSelect from '@/pages/SourceSelect';
import WelcomePage from '@/pages/Welcome';
import Vod from '@/pages/Vod';
import EPGGuide from '@/pages/EPGGuide';

import Requests from '@/helpers/Request';
import Registration from '@/helpers/Registration';
import store from '@/store';
import device from '@/store/modules/device';

Vue.use(Router);

const parseQueryString = (value) => {
  if (!value) return;
  const decoded = decodeURI(value);
  if (decoded[0] === '"') {
    return decoded.substring(1, decoded.length - 1);
  }
  return decoded;
};

const router = new Router({
  routes: [
    {
      path: '/demo',
      name: 'Demo',
      component: Demo,
    },
    {
      path: '/info',
      component: Info,
      children: [
        {
          path: 'keyhandling',
          component: KeyHandling,
        },
        {
          path: '',
          name: 'Info',
          component: InfoDashboard,
        },
      ],
    },
    // {
    //   path: '/image/:src/:alt',
    //   name: 'Image',
    //   component: Image,
    //   props: true,
    // },
    // {
    //   path: '/video/:src',
    //   name: 'Video',
    //   component: Video,
    //   props: true,
    // },
    // {
    //   path: '/website/:url',
    //   name: 'Website',
    //   component: Website,
    //   props: true,
    // },
    //TODO: SubVodMenu -> SubMenu
    {
      path: '/sub-menu/VodList',
      component: SubVodMenu,
      name: 'SubVodMenu',
      props: true,
      beforeEnter: async (to, from, next) => {
        /*if (!to.params.id) {
          next({ name: 'Home' });
        }*/
        await store.dispatch('vod/fetchVodSubMenu', to.params);
        next();
      },
    },
    /*
    {
      path: '/sub-menu/language',
      component: SubMenu,
      name: 'SubMenu',
      props: true,
      beforeEnter: async (to, from, next) => {
        if (!to.params.id) {
          next({ name: 'Home' });
        }
        //if(to.params.id == 'VodList') {
        //  await store.dispatch('vod/fetchVodSubMenu', to.params);
        //} else {
          await store.dispatch('navigation/fetchSubMenu', to.params);
        //}
        next();
      },
    },
    */
    {
      path: '/sub-menu/:id?',
      component: SubMenu,
      name: 'SubMenu',
      props: true,
      beforeEnter: async (to, from, next) => {
        if (!to.params.id) {
          next({ name: 'Home' });
        }
        //if(to.params.id == 'VodList') {
        //  await store.dispatch('vod/fetchVodSubMenu', to.params);
        //} else {
          await store.dispatch('navigation/fetchSubMenu', to.params);
        //}
        next();
      },
    },
    // {
    //   path: '/sub-menu',
    //   redirect: { name: 'Home' },
    // },
    {
      path: '/sub-vodmenu/:id?',
      component: SubVodMenu,
      name: 'VodSubMenu',
      props: true,
      beforeEnter: async (to, from, next) => {
        console.log("---------------------------------------TO_vod", to);
        if (!to.params.id) {
          next({ name: 'Vod' });
        }
        await store.dispatch('vod/fetchVodSubMenu', to.params);
        next();
      },
    },
    {
      path: '/registration',
      name: 'Registration',
      component: PageRegistration,
    },
    {
      path: '/media-player/:id?',
      component: MediaPlayer,
      name: 'MediaPlayer',
      props: (route) => {
        return {
          src: parseQueryString(route.query.src),
          type: parseQueryString(route.query.type),
          seekTo: parseQueryString(route.query.seekTo),
          title: parseQueryString(route.query.title),
          description: parseQueryString(route.query.description),
          loop: parseQueryString(route.query.loop) === '1',
          controls: parseQueryString(route.query.controls) !== 'false',
        };
      },
    },
    {
      path: '/tv-player',
      component: TVPlayer,
      name: 'TVPlayer',
      props: (route) => ({ origin: route.query.origin || 'home' }),
    },
    {
      path: '/radio-player',
      component: RadioPlayer,
      name: 'RadioPlayer',
    },
    {
      path: '/welcome',
      component: WelcomePage,
      name: 'WelcomePage',
    },
    {
      path: '/vod',
      component: Vod,
      name: 'Vod',
      props: true,
      /*
      beforeEnter: async (to, from, next) => {
        console.log('TO: ', to);
        //if(!to.params.id) {
        //  next({ name: 'Home' });
        //}
        await store.dispatch('vod/fetchVodMenu', to.params);
        next();
      },
      */
    },
    {
      path: '/epg-guide',
      component: EPGGuide,
      name: 'EPGGuide',
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter(to, from, next) {
        store.dispatch('navigation/callNextActionCallback');
        next();
      },
    },
    {
      path: '/init-device/:bid/:deviceId/:room',
      name: 'InitDevice',
      beforeEnter(to, from, next) {
        console.log(to), Registration.saveData(to.params);
        next({ name: 'Home' });
      },
    },
    {
      path: '/input-source',
      component: InputSource,
      props: true,
      name: 'InputSource',
    },
    {
      path: '/sourceselect',
      component: SourceSelect,
      props: true,
      name: 'SourceSelect',
    },
  ],
});//.catch(() => {});

router.beforeEach(async (to, from, next) => {
  store.commit('setIsLoadedState', false);
  // store.dispatch('notification/new', {
  //   title: 'To ' + to.name,
  //   message: 'Path: ' + to.path,
  // });
  //console.log('TO', to);
  try {
    store.dispatch('lang/init');
  } catch (err) {
    return location.reload(true);
  }
  if (
    to.name === 'Registration' ||
    to.name === 'Demo' ||
    to.name === 'SubMenu' ||
    to.name === 'Website' ||
    to.name === 'Video' ||
    to.name === 'Image' ||
    to.name === 'Vod' ||
    to.name === 'SubVodMenu' ||
    to.name === 'InitDevice' ||
    to.path.includes('/info') ||
    to.path.includes('/init-device')
  ) {
    store.commit('setIsLoadedState', true);
    return next();
  }

  const { bid, deviceId, room } = Registration.getData;
  // store.dispatch('notification/new', {
  //   title: 'Registrated data',
  //   message: `Bid: ${bid}, DeviceId: ${deviceId}, Room: ${room}`,
  // });
  if (!bid || !deviceId || !room) {
    // store.dispatch('notification/new', {
    //   title: 'No Params',
    // });
    store.commit('setIsLoadedState', true);
    return next({ name: 'Registration' });
  }

  try {
    await store.dispatch('device/init');
  } catch (err) {
    // store.dispatch('notification/new', {
    //   title: 'Device/init failed',
    // });
    console.log('Error: router:device/init - ', err);
    store.commit('setIsLoadedState');
    // ! NO DEVICE RESET POSSIBLE => SOCKET CALL NEEDED
    //return next({ name: 'Registration' });

    return location.reload(true);
  }

  // HAVE TO HANDLE REQUEST

  store.dispatch('customizer/fetchCustomizerSettings').catch((err) => {
    console.log('Error: router:customizer/fetchCustomizerSettings - ', err);
  });
  store.dispatch('socket/init').catch((err) => {
    console.log('Error: router:socket/init – ', err);
  });
  /*store.dispatch('logger/init').catch((err) => {
    console.log('Error: router:logger/init – ', err);
  });*/
  store.dispatch('navigation/init').catch((err) => {
    console.log('Error: router:navigation/init - ', err);
  });
  /*store.dispatch('vod/init').catch((err) => {
    console.log('Error: router:vod/init - ', err);
  });*/

  store.commit('setIsLoadedState');
  // END
  return next();
});

export default router;
1;



// WEBPACK FOOTER //
// ./src/router/index.js